import React from 'react';
import { pdf } from '@react-pdf/renderer';
import FileSaver from 'file-saver';

import { printPdfBlob } from '../../../utils/printPdfBlob';
import ActiveEnterprisesPDFTemplate from '../components/ActiveEnterprisesPDFTemplate';

export const generateActiveEnterprisesPdfBlob = async (data, columns, formatIdCard) =>
  pdf(
    <ActiveEnterprisesPDFTemplate data={data} columns={columns} formatIdCard={formatIdCard} />,
  ).toBlob();

export const downloadActiveEnterprisesAsPdf = async (
  data,
  columns,
  fileName = 'active_enterprises',
  formatIdCard,
) => {
  const date = new Date().toISOString().split('T')[0];
  const blob = await generateActiveEnterprisesPdfBlob(data, columns, formatIdCard);
  FileSaver.saveAs(blob, `${fileName}_${date}.pdf`);
};

export const printActiveEnterprisesAsPdf = async (data, columns, formatIdCard) => {
  const blob = await generateActiveEnterprisesPdfBlob(data, columns, formatIdCard);
  await printPdfBlob(blob);
};
